export const forBusiness_furniture_crafted = [
	{
		icon: '💑',
		title: 'craftedData_title1',
		subtitle: 'craftedData_subtitle1',
	},
	{
		icon: '🚀',
		title: 'craftedData_title2',
		subtitle: 'craftedData_subtitle2',
	},
	{
		icon: '🖼',
		title: 'craftedData_title3',
		subtitle: 'craftedData_subtitle3',
	},
	{
		icon: '🤘',
		title: 'craftedData_title4',
		subtitle: 'craftedData_subtitle4',
	},
];
